<template>
  <div>
    <h1>Purposes</h1>
    <p>Use this form to add more payment purposes</p>
    <v-btn @click="dialog = true">
      <v-icon>add</v-icon>Purpose
    </v-btn>
    <v-data-table
      :headers="headers"
      :items="purposes"
      hide-actions
      class="elevation-1"
      :pagination.sync="pagination"
      v-if="purposes"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.body }}</td>
          <td>
            <v-btn @click="deletePurpose(props.item)" small>Archive</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" width="300">
      <v-card>
        <v-card-text>
          <h3>Purpose</h3>
          <p>Please enter a title which describes the purpose of the payment request</p>
          <v-form ref="formPurpose" v-model="valid" lazy-validation>
            <v-text-field label="Body" v-model="purpose.body" :rules="valueRules" outline />
            <v-btn @click="savePurpose">
              <v-icon>save</v-icon>
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Purpose",
  metaInfo() {
    return {
      title: "Purpose",
      titleTemplate: "%s - Payments - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      purposes: null,
      purpose: {},
      dialog: false,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Body",
          value: "body"
        },
        {
          text: " ",
          sortable: false
        }
      ],
      pagination: {
        sortBy: "body",
        descending: false,
        page: 1,
        rowsPerPage: -1
      },
      valid: false,
      valueRules: [v => !!v || "Value is required"]
    };
  },
  methods: {
    fetchPurposes() {
      nbmlaw.get(`/cors/admin/payment/purposes`).then(response => {
        // console.log(response.data);
        this.purposes = response.data;
      });
    },
    savePurpose() {
      if (this.$refs.formPurpose.validate()) {
        nbmlaw.post(`/cors/admin/payment/purposes`, this.purpose).then(() => {
          // console.log(response.data);
          this.fetchPurposes();
          this.dialog = false;
        });
      }
    },
    deletePurpose(item) {
      if (confirm("Are you sure?")) {
        nbmlaw.delete(`/cors/admin/payment/purposes/${item.id}`).then(() => {
          // console.log(response.data);
          this.fetchPurposes();
        });
      }
    }
  },
  created() {
    this.fetchPurposes();
  }
};
</script>